import { formatDaySpan, getCalendarDaysUntil } from './dateUtils';

/**
 * Distance-to-a-date status for HR letters / self-service documents.
 * Callers attach Lucide icons from `tone`. Do not invent a local days-left label.
 *
 * @param {string|null|undefined} validUntil
 * @param {string|null} [filePurgedAt] - Retention purge timestamp; trumps expiry
 * @returns {null|{tone:'removed'|'expired'|'expiring'|'valid', label:string, color:string, canDownload:boolean, purged?:boolean}}
 */
export function getLetterExpiryStatus(validUntil, filePurgedAt = null) {
  if (filePurgedAt) {
    return {
      tone: 'removed',
      label: 'Removed',
      color: 'bg-gray-200 text-gray-700',
      canDownload: false,
      purged: true,
    };
  }

  if (!validUntil) return null;

  const daysLeft = getCalendarDaysUntil(validUntil);
  if (daysLeft == null) return null;

  if (daysLeft < 0) {
    return {
      tone: 'expired',
      label: 'Expired',
      color: 'bg-red-100 text-red-800',
      canDownload: false,
    };
  }

  if (daysLeft === 0) {
    return {
      tone: 'expiring',
      label: 'Expires today',
      color: 'bg-yellow-100 text-yellow-800',
      canDownload: true,
    };
  }

  if (daysLeft <= 7) {
    return {
      tone: 'expiring',
      label: `Expires in ${formatDaySpan(daysLeft, 'long')}`,
      color: 'bg-yellow-100 text-yellow-800',
      canDownload: true,
    };
  }

  return {
    tone: 'valid',
    label: `Valid (${formatDaySpan(daysLeft, 'long')} left)`,
    color: 'bg-green-100 text-green-800',
    canDownload: true,
  };
}
